export function ApiKeysPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">API Keys</h1>
      
      <div className="card">
        <p className="text-gray-600">
          API key management is handled by your administrator. Contact your admin to request new API keys or rotate existing ones.
        </p>
        
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <h3 className="font-medium text-blue-900">How to use your API key</h3>
          <p className="mt-2 text-sm text-blue-800">
            Include your API key in the <code className="bg-blue-100 px-1 rounded">x-api-key</code> header of all API requests:
          </p>
          <pre className="mt-2 p-3 bg-blue-100 rounded text-xs overflow-x-auto">
{`curl -X POST https://api.example.com/v1/labels/zpl \\
  -H "Content-Type: application/json" \\
  -H "x-api-key: elk_your_api_key_here" \\
  -d '{"templateKey": "your-template", "data": {...}}'`}
          </pre>
        </div>
      </div>
    </div>
  );
}
